// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__0SVAD","contentContainer":"Home_contentContainer__x3xVs"};